import axios from '@/plugin/axios';

export const getAllAnnualReports = () => axios.get('/organization_yearly_reports/');

export const getAnnualReports = (organizationId) =>
  axios.get(`/organizations/${organizationId}/view_yearly_reports/`);

export const submitAnnualReport = ({ organizationId, data }) =>
  axios.post(`/organizations/${organizationId}/submit_yearly_report/`, data, {
    headers: {
      'Content-Type': 'multipart/form-data',
    },
  });

export const approveAnnualReport = (reportId) => axios.get(`/yearly_reports/${reportId}/approve/`);
